// src/Navbar.js

import './impstyles.css'
import { useEffect } from "react";


import Icon1 from "../assets/Home/logo3.png"
import Icon2 from "../assets/Home/logo2.png"
import Icon3 from "../assets/Home/logo1.png"
import Navbar from "../components/Navbar.js";
import HomeHero from "../components/HomeHero.js";
import HeroAnimated from "../components/HeroAnimated.js";
import Footer from "../components/Footer.js";




const Navbar1 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (window.scrollY > 50) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <Navbar/>
      <div className="spacer"></div>
       <HeroAnimated/>
      <HomeHero />
     


      {/* Heading section */}
      <div className="heading-section">
        <h2>
          "Behind every product is a floor full of people who drive the process—
          <span className="highlight"> Let’s make their job less chaotic."</span>
        </h2>
      </div>

      <div className="container_use_case">
        <div className="text-section_use_case">
          <h2>ACHIEVE END-TO-END VISIBILITY</h2>
          <div className="product-visibility_use_case">
            <h1>99.9%</h1>
            <p>Product Visibility</p>
          </div>{" "}
          <hr></hr>
          <div className="material-tracking_use_case">
            <h2>24/7</h2>
            <p>Real-Time Material Tracking</p>
          </div>
          <ul className="features-list_use_case">
            <li>Full product traceability with DPP.</li>
            <li>Real-time defect detection, reducing waste.</li>
            <li>Automated compliance for easy audits.</li>
            <li>Lower costs with optimized processes.</li>
            <li>Track recyclables for sustainability.</li>
            <li>Data-driven insights for smarter decisions.</li>
          </ul>
          <div className="know_more_text_right">
            <a href="/supplychain" className="know_more_text_text_right">
              KNOW MORE
            </a>
            <span className="arrow_text_right">→</span>
          </div>
        </div>
        <div className="image-section_use_case">
          <img
            src="Complete Product Tracking.png"
            className="tracking-image_use_case"
          />
        </div>
      </div>

      <div className="container_text_right">
        <div className="image_section_text_right">
          <img
            src="Productivity 2.png"
            alt="Product Line"
            className="tracking_image_text_right"
          />
        </div>
        <div className="text_section_text_right">
          <h1 className="header_text_right">EASY SAFETY CHECK</h1>
          <div className="product_visibility_text_right">
            <h2 className="percentage_text_right">50%</h2>
            <p className="description_text_right">
              Reduction in Safety Incident
            </p>
          </div>
          <hr></hr>
          <div className="material_tracking_text_right">
            <h2 className="availability_text_right">65%</h2>
            <p className="tracking_description_text_right">
              Faster Compliance Check
            </p>
          </div>
          <ul className="features_list_text_right">
            <li className="feature_item_text_right">
              Fewer production delays and reduced rework costs.
            </li>
            <li className="feature_item_text_right">
              Less manual oversight, freeing up resources.
            </li>
            <li className="feature_item_text_right">
              Lower waste, leading to better inventory management.
            </li>
            <li className="feature_item_text_right">
              Lower costs with optimized processes.
            </li>
            <li className="feature_item_text_right">
              Reduced downtime, increased operational efficiency.
            </li>
            <li className="feature_item_text_right">
              Smarter decisions with real-time insights, driving better
              outcomes.
            </li>
          </ul>
          <div className="know_more_text_right">
            <a href="/security" className="know_more_text_text_right">
              KNOW MORE
            </a>
            <span className="arrow_text_right">→</span>
          </div>
        </div>
      </div>

      <div className="container_use_case">
        <div className="text-section_use_case">
          <h2>STREAMLINE PRODUCTION</h2>
          <div className="product-visibility_use_case">
            <h1>70%</h1>
            <p>Faster Operations</p>
          </div>
          <hr></hr>
          <div className="material-tracking_use_case">
            <h2>60%</h2>
            <p>Reduction in Operational Delays</p>
          </div>
          <ul className="features-list_use_case">
            <li>Faster production means quicker deliveries.</li>
            <li>Less manual work lets staff focus on key tasks.</li>
            <li>Better batch & lot tracking reduces costs.</li>
            <li>Lower costs with optimized processes.</li>
            <li>Optimized workforce boosts efficiency.</li>
            <li>Streamline operations, unlock new revenue opportunities</li>
          </ul>
          <div className="know_more_text_right">
            <a href="/smart" className="know_more_text_text_right">
              KNOW MORE
            </a>
            <span className="arrow_text_right">→</span>
          </div>
        </div>
        <div className="image-section_use_case">
          <img src="Safety 2.png" className="tracking-image_use_case" />
        </div>
      </div>

      <div className="App">
        <header className="header">
          <h1 style={{ fontWeight: "500" }}>Let Argus Take It from Here</h1>
        </header>

        <div className="card-container">
          <div className="card">
            <div className="icon" >
              <img src={Icon1} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h2>On-Prem Deployment</h2>
            <p>
              Runs directly inside your facility, keeping production & operational data private.
            </p>
          </div>

          <div className="card">
            <div className="icon">
              <img src={Icon2} style={{margin:"0", height:"70px"}} alt="Icon 2" />
            </div>
            <h2>Visual Root Cause</h2>
            <p>
              Understand machine stoppages by connecting operational layers & material flow.
            </p>
          </div>

          <div className="card">
            <div className="icon" >
              <img src={Icon3} style={{margin:"0", height:"70px"}} alt="Icon 3" />
            </div>
            <h2>Lower Cost</h2>
            <p>Uses existing infrastructure, creating a closed-loop system that removes extra fees.</p>
          </div>
        </div>
      </div>

      <hr></hr>

      <div className="app-container213">
        <header className="app-header213">
          <h1 className="title213">The Numbers</h1>
        </header>

        <div className="statistics-container213">
          <div className="statistic-card213">
            <h2 className="statistic-percentage213">20%</h2>
            <div className="card-divider213"></div>
            <p className="statistic-description213">Operations Cost Reduce</p>
          </div>

          <div className="statistic-card213">
            <h2 className="statistic-percentage213">50%</h2>
            <div className="card-divider213"></div>
            <p className="statistic-description213">Production Increase</p>
          </div>

          <div className="statistic-card213">
            <h2 className="statistic-percentage213">40%</h2>
            <div className="card-divider213"></div>
            <p className="statistic-description213">Increased Throughput</p>
          </div>

          <div className="statistic-card213">
            <h2 className="statistic-percentage213">30%</h2>
            <div className="card-divider213"></div>
            <p className="statistic-description213">
              Accelerate time-to-market
            </p>
          </div>
        </div>
      </div>
<div>
</div>
      <Footer />
    </div>
  );
};

export default Navbar1;
